import { makeAutoObservable } from 'mobx'
import { authStore } from './Auth'

class PopupAuthStore {
  isVisible = false

  loadCheckAuth = false

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  async show() {
    this.setLoadCheckAuth(true)
    try {
      const isAuth = await authStore.checkAuth()
      if (!isAuth) {
        this.isVisible = true
        document.body.style.overflow = 'hidden'
      }
    } catch (e) {
      console.error('e', e)
    } finally {
      this.setLoadCheckAuth(false)
    }
  }

  hide() {
    this.isVisible = false
    document.body.style.overflow = 'auto'
  }

  setLoadCheckAuth(value: boolean) {
    this.loadCheckAuth = value
  }
}

export const popupAuthStore = new PopupAuthStore()
